import { MarketListedItem } from "../types/MarketListedItem";
import { getInventoryItemInfoById } from "./profile";

export const parseMarketListedItem = (item: any) => {
  return {
    listingId: item.id,
    categoryId: getInventoryItemInfoById(item.UserInventory.item_id)
      ?.categoryId,
    typeId: getInventoryItemInfoById(item.UserInventory.item_id)?.typeId,
    cityId: item.UserInventory.city,
    bidCount: item.bidCount,

    listingInfo: {
      itemId: item.itemId,
      listingType: item.listingType,
      startingPrice: item.startingPrice,
      currentPrice: item.currentPrice,
      timestamp: item.timestamp,
      expiresAt: item.expiresAt,
      token: item.token,
      seller: item.seller,
      buyer: item.buyer,
      status: item.status,
      bids: [],
    },

    slotData: item.Map
      ? {
          slotRarity: item.Map.slotRarity,
          cityId: item.Map.city,
          slotX: item.Map.slotX,
          slotY: item.Map.slotY,
          slotSubType: item.Map.slotSubType,
          slotType: item.Map.slotType,
        }
      : null,
  } as MarketListedItem;
};

export const parseNewListingEvent = (event: any) => {
  return {
    listingId: Number(event.returnValues.listingId),
    listingToken: event.returnValues.listingToken,
    seller: event.returnValues.seller,
    itemId: Number(event.returnValues.itemId),
    listingType: Number(event.returnValues.listingType),
    startingPrice: Number(event.returnValues.startingPrice),
    timestamp: Number(event.returnValues.timestamp),
    expiresAt: Number(event.returnValues.expiresAt),
  };
};
